<div class="modal-backdrop fade show" @click="close_file_preview_modal"></div>
<div class="modal show d-block" tabindex="-1">
  <div class="modal-dialog modal-xl modal-dialog-centered" @click.stop>
    <div class="modal-content">
      <div class="modal-header shadow-lg modal-lg modal-dialog-centered">
        <h5 class="modal-title d-flex align-items-center">
          <p class="text-black">Previewing File</p>
        </h5>
        <button type="button" class="btn-close " @click="close_file_preview_modal" aria-label="Close"></button>
      </div>
      <div class="modal-body p-0">

        <!-- Preview content -->
        <div class="h-100">
          <!-- PDF files -->
          <iframe
            v-if="file_type === 'pdf'"
            :key="'pdf-' + iframe_key"
            :src="preview_url"
            width="100%"
            height="500px"
            frameborder="0">
          </iframe>

          <!-- Microsoft Office documents -->
          <iframe
            v-else-if="['doc', 'docx', 'xls', 'xlsx', 'xlsm', 'xlsb', 'ppt', 'pptx'].includes(file_type)"
            :key="'office-' + iframe_key"
            :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(preview_url)"
            width="100%"
            height="500px"
            frameborder="0">
          </iframe>

          <!-- Images -->
          <img
            v-else-if="['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(file_type)"
            :key="'image-' + iframe_key"
            :src="preview_url"
            :alt="file_name"
            class="img-fluid w-100"
            height="500px">

          <!-- Videos -->
          <video
            v-else-if="['mp4', 'webm', 'avi', 'mov', 'wmv'].includes(file_type)"
            :key="'video-' + iframe_key"
            :src="preview_url"
            controls
            class="w-100"
            height="500px">
            Your browser does not support the video tag.
          </video>

          <!-- Audio -->
          <div v-else-if="['mp3', 'wav', 'ogg', 'm4a'].includes(file_type)" class="d-flex justify-content-center align-items-center h-100 bg-dark">
            <audio :src="preview_url" controls class="w-75"></audio>
          </div>

          <!-- Text files -->
          <iframe
            v-else-if="['txt', 'json', 'xml'].includes(file_type)"
            :key="'text-' + iframe_key"
            :src="preview_url"
            width="100%"
            height="500px"
            frameborder="0">
          </iframe>

          <!-- Unsupported files -->
          <div v-else class="d-flex justify-content-center align-items-center h-100 bg-light">
            <div class="text-center p-4">
              <i class="fas fa-file-excel display-4 text-secondary mb-3"></i>
              <h4>Preview not available</h4>
              <p class="text-muted">This file type cannot be previewed in the browser.</p>
              <a :href="preview_url" :download="file_name" class="btn btn-primary d-none">
                Download File
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer bg-light">
        <a v-if="preview_url && can_download" :href="preview_url" :download="file_name" class="btn cta-button text-white">
          Download
        </a>
      </div>
    </div>
  </div>
</div>